/** Сколько ждём живого воркера, прежде чем идти дальше без него. */
export const SERVICE_WORKER_WAIT_MS = 3_000;

/**
 * Ждём живого service worker - и обязательно наперегонки с таймером.
 *
 * Регистрацию мы передаём в Firebase сами (`firebase.ts`), а раз передаём, SDK пропускает
 * собственное ожидание активации. На ещё устанавливающемся воркере `pushManager.subscribe()`
 * падает с InvalidStateError, обёртка его проглатывает и возвращает null - человек разрешил
 * уведомления и не получил ничего, а в настройках написано «браузер не зарегистрирован». Чаще
 * всего это первый визит: воркер регистрируется по событию `load` страницы, то есть ПОЗЖЕ, чем
 * гидрация успевает спросить токен.
 *
 * 🔴 Гонка с таймером обязательна: `navigator.serviceWorker.ready` никогда не отклоняется и
 * никогда не разрешается, если воркера не регистрировали вовсе - без таймера ожидание зависло
 * бы навсегда. По истечении срока идём дальше и даём обёртке зарегистрировать его самой.
 *
 * Общее на два места: шторка разрешений и тихая сверка токена. Копия во втором и была причиной
 * того, что тихая сверка спрашивала токен до появления воркера.
 */
export const waitForServiceWorker = async (): Promise<void> => {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }
  try {
    await Promise.race([
      navigator.serviceWorker.ready,
      new Promise((resolve) => setTimeout(resolve, SERVICE_WORKER_WAIT_MS)),
    ]);
  } catch {
    // Воркер недоступен - пробуем забрать токен как есть.
  }
};
